var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnchained(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M22 27s.8 1.7-1.1 3.5l-5.6 5.6c-3.2 3.2-4.7 1.2-7.3-1.3-2.6-2.6-4.6-4-1.3-7.3l5.6-5.6c1.9-1.9 3.5-1.1 3.5-1.1M27.2 21.8s1.7.8 3.5-1.1l5.6-5.6c3.2-3.2 1.2-4.7-1.3-7.3s-4-4.6-7.3-1.3l-5.6 5.6C20.2 14 21 15.6 21 15.6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.1 27.3h8M27.4 31v8M15.2 11.5v-8M11.5 15.2H3.6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.4,
    cy: 21.4,
    r: 1.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnchained);
export default __webpack_public_path__ + "static/media/unchained.8a9feac383a6fa765443832cfbe23f9c.svg";
export { ForwardRef as ReactComponent };